import styled, { css } from 'styled-components';
import { mobile_xl, mobile_xs, tablet_s } from '../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../global/commonStyle';

const Main = styled.div`
  max-width: 662px;
  width: 100%;
  margin: var(--space-16) auto var(--space-0);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  ${mobile_xl(css`
    margin: var(--space-0) auto;
    .fourth-block {
      display: none;
    }
    .fifth-block {
      display: none;
    }
  `)}
`;
const FirstBlock = styled.div`
  padding: var(--space-12) var(--space-16) var(--space-12) var(--space-18);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  display: flex;
  gap: var(--space-12);
  z-index: var(--z-index-111);
  ${mobile_xl(css`
    z-index: var(--z-index-0);
    padding: var(--space-12) var(--space-12) var(--space-12) var(--space-18);
    gap: var(--space-16);
  `)}
`;
const Avatar = styled.div`
  width: 28px;
  height: 28px;
  &.avatar {
    width: 20px;
    height: 20px;
  }
`;
const Profile = styled.div`
  width: 28px;
  height: 28px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  &.avatar {
    width: 20px;
    height: 20px;
  }
`;
const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  &.right-side {
    flex-direction: row;
    gap: var(--space-16);
    justify-content: space-between;
    width: 100%;
  }
  ${mobile_xl(css`
    gap: var(--space-8);
    width: 100%;
    &.right-side {
      flex-direction: column;
      gap: var(--space-8);
    }
  `)}
`;
const SubDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
  padding-top: var(--space-5);
  &.right-side {
    padding-bottom: var(--space-5);
  }
  ${mobile_xl(css`
    &.third-block {
      flex-direction: column-reverse;
    }
    &.right-side {
      padding-bottom: var(--space-0);
    }
  `)}
`;
const Top = styled.div`
  width: 162px;
  height: 10px;
  border-radius: var(--border-radius-6);
  background-color: var(--background-muted);
  &.bottom {
    width: 463px;
  }
  &.right {
    width: 200px;
  }
  &.top {
    width: 481px;
  }
  &.bottomLine {
    width: 463px;
  }
  ${tablet_s(css`
    &.bottomLine {
      width: 342px;
    }
    &.top {
      width: 318px;
    }
    &.bottom {
      width: 344px;
    }
  `)}
  ${mobile_xl(css`
    &.bottom {
      width: -webkit-fill-available;
    }
    &.top {
      width: 210px;
    }
    &.top-bottom {
      width: 116px;
    }
    &.right {
      width: 100%;
    }
    &.bottomLine {
      width: 100%;
    }
  `)}
`;

const Bottom = styled.div`
  width: 112px;
  height: 26px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  &.first {
    width: 99px;
  }
  &.second {
    width: 90px;
  }
  ${mobile_xl(css`
    &.second {
      display: none;
    }
  `)}
`;
const LeftSide = styled.div`
  width: 62px;
  height: 16px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Subbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;

const SubBlock = styled.div`
  padding: var(--space-11);
  border-radius: var(--border-radius-8);
  width: 483px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${tablet_s(css`
    width: 100%;
    max-width: -webkit-fill-available;
  `)}
`;

const BottomDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const LeftDiv = styled.div`
  width: 88px;
  height: 74px;
  ${mobile_xs(css`
    width: 68px;
    height: 68px;
  `)}
`;

const Square = styled.div`
  width: 88px;
  height: 74px;
  border-radius: var(--border-radius-4);
  background-color: var(--background-muted);
  ${mobile_xs(css`
    width: 68px;
    height: 68px;
  `)}
`;
const RightDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    width: 100%;
  `)}
`;
const Detail = styled.div`
  ${AlignCenter}
  gap: var(--space-5);
`;
const ButtonDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;
const Box = styled.div`
  padding: var(--space-10) var(--space-12);
  border-radius: var(--border-radius-8);
  width: 481px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  display: flex;
  flex-direction: column;
  gap: var(--space-14);
  ${tablet_s(css`
    width: 100%;
    max-width: -webkit-fill-available;
  `)}
`;
const ResponsiveBottomDiv = styled.div`
  display: none;
  width: 62px;
  height: 16px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    display: flex;
  `)}
`;
export {
  Main,
  FirstBlock,
  Profile,
  RightSide,
  Top,
  Bottom,
  SubDiv,
  LeftSide,
  Avatar,
  Subbox,
  SubBlock,
  BottomDiv,
  LeftDiv,
  RightDiv,
  Square,
  Detail,
  ButtonDiv,
  Box,
  ResponsiveBottomDiv
};
